import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import { Grid } from "../Grid";
import { CreateStaticSelectColumnFilter } from "../../leap-components/Grid/FetchGrid/StaticSelectColumnFilter";
import { ChangeRequestsGridProps } from "./ChangeRequestsGridProps";
import {
  GetLicenceChangeRequestsByLicenceFetchUrl,
  IChangeRequestRow,
} from "../../api/IChangeRequests";

const ChangeRequestsGrid = ({
  licenceId,
  licenceProfile,
  changeRequestsStatuses,
}: ChangeRequestsGridProps) => {
  const GetUrlForChangeRequest = (
    profileNumber: string,
    licenceId: string,
    changeRequestId: string
  ) => {
    return `/licence-profile/${profileNumber}/versions/${licenceId}/change-request/${changeRequestId}`;
  };

  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetLicenceChangeRequestsByLicenceFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(licenceId);

  const tableColumnsBig: Column<Record<string, IChangeRequestRow>>[] = [
    {
      Header: "Case No.",
      accessor: "casenumber",
      Filter: false,
      filter: "casenumber",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetUrlForChangeRequest(
                  licenceProfile.profileNo,
                  rowInfo.row.original.licenceid,
                  rowInfo.row.original.licencechangerequestid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Amendment Title",
      accessor: "title",
      Filter: false,
      filter: "includes",
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: CreateStaticSelectColumnFilter(
        changeRequestsStatuses.list.map((option) => option.value)
      ),
    },
    {
      Header: "Request Date",
      accessor: "requestdate",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Issued Date",
      accessor: "issueddate",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
  ];

  const tableColumnsSmall: Column<Record<string, IChangeRequestRow>>[] = [
    {
      Header: "Case No.",
      accessor: "casenumber",
      Filter: false,
      filter: "casenumber",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetUrlForChangeRequest(
                  licenceProfile.profileNo,
                  rowInfo.row.original.licenceid,
                  rowInfo.row.original.licencechangerequestid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Amendment Title",
      accessor: "title",
      Filter: false,
      filter: "includes",
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { ChangeRequestsGrid };
